export default {
    namespaced: true,
    state: {
        background: '',
        color: '',
        logo: '',
        loading: true
    },
    mutations: {
        setData(state, data) {
            state.background = data.background;
            state.color = data.color;
            state.logo = data.logo;
        },
        finishLoading(state) {
            state.loading = false
        }
    }
}
